import React,{useEffect} from 'react';
import { useSetRecoilState } from 'recoil';
import { authDetail } from '../../recoil';
import { StaticRoutes } from '../../Router';
import { removeActiveSession } from '../../api/vodaLend/logout';
import { Loader } from '../../components';
import { useTealium} from '../../tealium/useTealium';
import {OPFBROADCASTCHANNEL,LOGOUTBROADCASTMESSAGE} from '../../constants/constant.js';

export const Logout = () => {
  const resetLogin = useSetRecoilState(authDetail);
  const { track, events } = useTealium();

  useEffect(() => {
    track(events.logout.pageView());
  }, []);

  React.useEffect(() => {
    const performLogout = async () => {
      await removeActiveSession();
      resetLogin(null);
      sessionStorage.removeItem('loanApplicationStepKey');
      sessionStorage.removeItem('businessId');
      sessionStorage.removeItem('businessName');
      sessionStorage.removeItem('opf:sessionContext');
      sessionStorage.removeItem('isNewBusiness');

      const channel = new BroadcastChannel(OPFBROADCASTCHANNEL);
      channel.postMessage({ type: LOGOUTBROADCASTMESSAGE });
      channel.close();
      window.location.href = StaticRoutes.login;
      track(events.logout.logout());
    };

    performLogout();
  }, [resetLogin]);

  return (
    <Loader/>
  );
};